import { render } from "./Step2Cargo.vue?vue&type=template&id=6d2e4a00&scoped=true"
import script from "./Step2Cargo.vue?vue&type=script&lang=js"
export * from "./Step2Cargo.vue?vue&type=script&lang=js"

import "./Step2Cargo.vue?vue&type=style&index=0&id=6d2e4a00&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d2e4a00"]])

export default __exports__